module.exports = __webpack_public_path__ + "static/img/case-7caoyuan.3e5ef92e.jpg";